import * as React from 'react';
import Utils from "../../../../../../Utils";
import Modal from "react-responsive-modal";
import Input from '../../../../../common/Input/Input'
import './createFunctionalitiesModalStyles.css'
import InputUtils, {Type} from "../../../../../../InputUtils";
import {Routes} from "../../../../../../config/routes";

interface Props {
    createFunctionality(dto): void,

    editFunctionality(funcId, dto): any,

    restoreEventListener(): void,

    hideModal(): void,

    showModal: boolean,
    selectedFunctionality: any,
    modalData: any,
}

interface State {
    validateForm: boolean;
    formIsValid: boolean;
    form: any,
}

enum DEFAULT_ERROR_MSG {
    UI_ROUTES = 'Routes field cannot be empty',
    FUNCTIONALITY_NAME = 'Name field cannot be empty',
    API_ENDPOINTS = 'Endpoints field cannot be empty',
    DESCRIPTION = 'Description field cannot be empty',
}

class CreateFunctionalityModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            validateForm: false,
            formIsValid: true,
            form: {
                functionalityName: {
                    value: '',
                    valid: true,
                    errorMsg: DEFAULT_ERROR_MSG.FUNCTIONALITY_NAME
                },
                description: {
                    value: '',
                    valid: true,
                    errorMsg: DEFAULT_ERROR_MSG.DESCRIPTION
                },
                apiEndpoints: {
                    value: [],
                    valid: true,
                    options: [],
                    errorMsg: DEFAULT_ERROR_MSG.API_ENDPOINTS
                },
                uiRoutes: {
                    value: [],
                    valid: true,
                    options: [],
                    errorMsg: DEFAULT_ERROR_MSG.UI_ROUTES
                },
            }
        };
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (this.props.showModal && this.props.modalData !== prevProps.modalData) {
            this.loadDataToForm();
            document.addEventListener('keydown', this.keydownModalHandler);
        }
        if (this.props.showModal !== prevProps.showModal && !this.props.showModal) {
            document.removeEventListener('keydown', this.keydownModalHandler);
        }
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.keydownModalHandler);
    }

    keydownModalHandler = (e) => {
        if (e.keyCode === 13 && !e.target.id.includes('select')) {
            Utils.$('#btn-save').click();
        }
    }

    loadDataToForm = () => {
        let formCopy = JSON.parse(JSON.stringify(this.state.form));
        this.loadDropDownOptions(formCopy);

        if (this.props.selectedFunctionality) {
            const selectedFunctionality = JSON.parse(JSON.stringify(this.props.selectedFunctionality));
            const keys = Object.keys(selectedFunctionality);

            keys.forEach(key => {
                if (formCopy.hasOwnProperty(key)) {
                    if (key.toLowerCase() === 'apiendpoints' || key.toLowerCase() === 'uiroutes') {
                        formCopy = {
                            ...formCopy,
                            [key]: {
                                ...formCopy[key],
                                value: this.getLoadedDropDownValues(selectedFunctionality[key], key)
                            }
                        }
                    } else {
                        formCopy = {
                            ...formCopy,
                            [key]: {
                                ...formCopy[key],
                                value: selectedFunctionality[key] ? selectedFunctionality[key] : ''
                            }
                        }
                    }
                }
            })
        }
        this.setState({
            form: formCopy
        })
    }

    loadDropDownOptions = (form?: any) => {
        if (this.props.modalData.apiEndpoints.length > 0 && this.props.modalData.uiRoutes.length > 0) {
            if (form) {
                form.apiEndpoints.options = this.props.modalData.apiEndpoints;
                form.uiRoutes.options = this.props.modalData.uiRoutes;
            } else {
                let formCopy = JSON.parse(JSON.stringify(this.state.form));
                formCopy.apiEndpoints.options = this.props.modalData.apiEndpoints;
                formCopy.uiRoutes.options = this.props.modalData.uiRoutes;
                this.setState({
                    form: formCopy
                })
            }
        }
    }

    getLoadedDropDownValues = (values: any, field: string) => {
        const {modalData} = this.props;
        let found = [];
        values.forEach(val => {
            let searched = modalData[field].find(item => {
                if (field === 'apiEndpoints') {
                    const endPoint = `${val.method} ${val.url}`
                    return item.label === endPoint;
                } else {
                    return item.label.toLowerCase() === val.toLowerCase()
                }
            })
            if (searched) {
                found.push(searched);
            }
        })
        return found;
    }

    open = () => {
        this.resetForm();
        this.setState({
            formIsValid: true,
            validateForm: false,
        });
    };

    resetForm = () => {
        this.setState({
            form: InputUtils.resetForm(this.state.form)
        })
    }

    close = () => {
        this.resetForm();
        this.props.hideModal();
        this.props.restoreEventListener()
    };

    onChange = (event, id, inputType, option?: any) => {
        const formCopy = JSON.parse(JSON.stringify(this.state.form));
        let errorMsg = null;
        let eventValue;
        if (inputType.includes('select')) {
            eventValue = event ? event : [];
            this.setValueToForm(formCopy, id, eventValue, errorMsg);

        } else {
            eventValue = event.target.value;
            this.setValueToForm(formCopy, id, eventValue, errorMsg);
        }
    }

    setValueToForm = (formCopy: any, id: string, eventValue: any, errorMsg?: any) => {
        if (errorMsg) {
            this.setState({
                form: {
                    ...formCopy,
                    [id]: {
                        ...formCopy[id],
                        value: eventValue,
                        valid: false,
                        errorMsg: errorMsg
                    }
                }
            })
        } else {
            this.setState({
                form: {
                    ...formCopy,
                    [id]: {
                        ...formCopy[id],
                        value: eventValue,
                        valid: true,
                        errorMsg: this.getDefaultErrorMsg(id)
                    }
                }
            })
        }
    }

    getDefaultErrorMsg = (id: string) => {
        switch (id) {
            case "functionalityName":
                return DEFAULT_ERROR_MSG.FUNCTIONALITY_NAME;
            case 'apiEndpoints':
                return DEFAULT_ERROR_MSG.API_ENDPOINTS;
            case  'uiRoutes':
                return DEFAULT_ERROR_MSG.UI_ROUTES
        }
    }

    createFunctionalityHandler = () => {
        if (this.checkFormValidity()) {
            if (this.props.selectedFunctionality) {
                const dto = this.createEditDto();
                this.props.editFunctionality(this.props.selectedFunctionality.id, dto)
                    .then(response => {
                        if (response) {
                            // if response === undefined there are no changes.
                            setTimeout(() => {
                                this.resetForm();
                                this.props.restoreEventListener()
                            }, 200)
                        }
                    })
            } else {
                const dto = {
                    name: this.state.form.functionalityName.value,
                    description: this.state.form.description.value,
                    apiEndpoints: this.state.form.apiEndpoints.value.map(api => {
                        return api.id
                    }),
                    uiRoutes: this.state.form.uiRoutes.value.map(uiRoute => {
                        return uiRoute.label
                    })
                }
                this.props.createFunctionality(dto)
                this.resetForm();
                this.props.restoreEventListener()
            }
        }
    }

    createEditDto = () => {
        const addedApis = [];
        const removedApis = [];

        this.props.selectedFunctionality.apiEndpoints.forEach(item => {
            const found = this.state.form.apiEndpoints.value.find(api => api.id === item.id)
            if (!found) {
                removedApis.push(item.id);
            }
        })

        this.state.form.apiEndpoints.value.forEach(item => {
            const found = this.props.selectedFunctionality.apiEndpoints.find(api => api.id === item.id)
            if (!found) {
                addedApis.push(item.id);
            }
        });

        return {
            apiEndpoints: {
                add: addedApis,
                remove: removedApis
            },
            name: this.state.form.functionalityName.value,
            description: this.state.form.description.value,
            uiRoutes: this.state.form.uiRoutes.value.map(uiRoute => {
                return uiRoute.label
            })
        }
    }

    checkFormValidity = (): boolean => {
        const keys = Object.keys(this.state.form);
        const formCopy = JSON.parse(JSON.stringify(this.state.form));
        let formIsValid = true;
        keys.forEach((key, index) => {
            switch (key) {
                case 'functionalityName':
                    if ((formCopy[key].value === '' || this.checkIsNameUnique(formCopy[key].value)) || !formCopy[key].valid) {
                        formCopy[key].valid = false;
                        if (formCopy[key].value !== '') {
                            formCopy[key].errorMsg = `${formCopy[key].value} is already used`;
                        }
                        formIsValid = false;
                    }
                    break;
                case 'description':
                    if (formCopy[key].value === '') {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'apiEndpoints':
                    if (formCopy[key].value.length === 0 || !formCopy[key].valid) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'uiRoutes':
                    if (formCopy[key].value.length === 0 || !formCopy[key].valid) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
            }
        })

        this.setState({
            form: formCopy
        })

        return formIsValid;
    }

    checkIsNameUnique = (name: string) => {
        if (this.props.modalData.usedNames.length > 0) {
            if (this.props.selectedFunctionality &&
                this.props.selectedFunctionality.functionalityName === this.state.form.functionalityName.value) {
                return false;
            }
            return this.props.modalData.usedNames.includes(name);
        }
        return false;
    }

    render() {
        return (
            <Modal
                open={this.props.showModal}
                styles={{
                    overlay: {zIndex: 10000},
                    closeButton: {display: "none"},
                    modal: {
                        width: 750,
                        padding: 0,
                        maxWidth: 750,
                    }
                }}
                closeOnEsc={true}
                onClose={this.close}
                center
                focusTrapped={true}
                closeOnOverlayClick={false}
            >
                <div style={{width: '100%', height: '85%', backgroundColor: "#2B2B2B"}}>
                    <div className="row" style={{height: '100%'}}>
                        <div id={'create-user-container'} className='col-lg-12 compare-changes'>
                            <header className={'create-functionality-modal-header'}>
                                <h2>{this.props.selectedFunctionality ? 'Edit Functionality' : 'Create Functionality'}</h2>
                            </header>
                            <div className={'create-functionality-modal-container'}>
                                <div className={'createFunctionalityForm'}>
                                    <Input id={'functionalityName'}
                                           value={this.state.form.functionalityName.value}
                                           required={true}
                                           elementType={Type.INPUT}
                                           changed={(event) => this.onChange(event, 'functionalityName', 'input')}
                                           classNameProp={'input-full-width default-margin-inputs'}
                                           valid={this.state.form.functionalityName.valid}
                                           errorMsg={this.state.form.functionalityName.errorMsg}
                                           label={'Functionality Name'}
                                           elementConfig={{
                                               placeholder: 'Functionality Name',
                                               tabIndex: 1
                                           }}
                                    />
                                    <Input id={'apiEndpoints'}
                                           value={this.state.form.apiEndpoints.value}
                                           required={true}
                                           elementType={Type.SELECT}
                                           selectInitialPosition={true}
                                           changed={(event: any, option: any) => this.onChange(event, 'apiEndpoints', 'select', option)}
                                           classNameProp={'input-full-width default-margin-inputs'}
                                           valid={this.state.form.apiEndpoints.valid}
                                           errorMsg={this.state.form.apiEndpoints.errorMsg}
                                           label={'Api Endpoints'}
                                           wrapperClass={'half-width-float-left'}
                                           elementConfig={{
                                               placeholder: 'Api Endpoints',
                                               tabIndex: 2,
                                               isMulti: true,
                                               closeMenuOnSelect: false,
                                               options: this.props.modalData.apiEndpoints
                                           }}
                                    />
                                    <Input id={'uiRoutes'}
                                           value={this.state.form.uiRoutes.value}
                                           elementType={Type.SELECT}
                                           changed={(event) => this.onChange(event, 'uiRoutes', 'creatable-select')}
                                           classNameProp={'input-full-width default-margin-inputs custom-select-menu-initial-position'}
                                           required={true}
                                           selectInitialPosition={true}
                                           valid={this.state.form.uiRoutes.valid}
                                           errorMsg={this.state.form.uiRoutes.errorMsg}
                                           label={'Routes'}
                                           wrapperClass={'half-width'}
                                           elementConfig={{
                                               placeholder: 'Routes',
                                               tabIndex: 3,
                                               isMulti: true,
                                               closeMenuOnSelect: false,
                                               options: this.state.form.uiRoutes.options
                                           }}
                                    />
                                    <Input id={'description'}
                                           value={this.state.form.description.value}
                                           required={true}
                                           elementType={Type.TEXT_AREA}
                                           changed={(event) => this.onChange(event, 'description', 'input')}
                                           classNameProp={'input-full-width default-margin-inputs'}
                                           valid={this.state.form.description.valid}
                                           errorMsg={this.state.form.description.errorMsg}
                                           label={'Description'}
                                           elementConfig={{
                                               placeholder: 'Description...',
                                               tabIndex: 4,
                                               maxLength: 2048,
                                               rows: 5,
                                               cols: 70
                                           }}
                                    />
                                </div>
                            </div>
                            <footer style={{
                                background: "#2D3436",
                                borderTop: "2px solid #f5f5f5a3",
                                height: 49,
                                width: "100%",
                                paddingRight: 5,
                                paddingTop: 3,
                            }}>
                                <button
                                    onClick={this.createFunctionalityHandler}
                                    className={"btn"}
                                    id={'btn-save'}
                                    style={{float: "right", marginTop: 3, marginLeft: 4}}>
                                    <i className="fas fa-save"> Save</i>
                                </button>
                                <button
                                    onClick={this.close}
                                    className={"btn"}
                                    style={{float: "right", marginTop: 3, marginRight: 2}}>
                                    <i className="fas fa-times"> Close</i>
                                </button>
                            </footer>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default CreateFunctionalityModal



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/FunctionalitiesGrid/components/createUserModal/CreateFunctionalityModal.tsx